import { forwardRef } from 'react';
import {
  type NumberFormatValues,
  NumericFormat,
  type NumericFormatProps,
} from 'react-number-format';

const PRICE_DECIMAL_DIGITS_LIMIT = 2;

export type NumericFormatInputProps = Omit<NumericFormatProps, 'onChange'> & {
  name?: string;
  onChange: (event: { target: { name: string; value: unknown } }) => void;
  parseValue?: (values: NumberFormatValues) => unknown;
  ignoreProgrammaticChanges?: boolean;
};

function getStringValue(values: NumberFormatValues) {
  return values.value;
}

export const NumericFormatInput = forwardRef<HTMLInputElement, NumericFormatInputProps>(
  function NumericFormatInput(
    { onChange, name, parseValue = getStringValue, ignoreProgrammaticChanges, ...rest },
    ref,
  ) {
    return (
      <NumericFormat
        {...rest}
        name={name}
        getInputRef={ref}
        onValueChange={(values, { event }) => {
          if (ignoreProgrammaticChanges && !event) {
            return;
          }

          onChange({
            target: {
              name: name ?? '',
              value: parseValue(values),
            },
          });
        }}
        decimalScale={PRICE_DECIMAL_DIGITS_LIMIT}
        fixedDecimalScale
        thousandSeparator
        allowNegative={false}
        valueIsNumericString
        inputMode="decimal"
      />
    );
  },
);
